// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliwangwangFilledSvg from "@fishx/icons-svg/es/asn/AliwangwangFilled";
import FishxIcon from '../components/FishxIcon';

var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangFilledSvg
  }));
};

AliwangwangFilled.displayName = 'AliwangwangFilled';
export default React.forwardRef(AliwangwangFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AliwangwangFilled.js
// module id = 1969
// module chunks = 0